/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import {register} from '@shopify/theme-sections';
import SimpleProduct from '../ui/product-types/simple';
import $ from 'jquery';


$(function() {
  $('.options__item').on('click', function(event) {
    const productJSON =  JSON.parse($('[data-product-json]').html());
    const formArea = event.target.closest('form');
    const variantLabel = event.target.getAttribute('value'); 
    const label = formArea.querySelector('.options__title-result');
    label.innerHTML = variantLabel;
  });
})

register('product', SimpleProduct);
 